export function callbackSession(location) {
  const fragment = new URLSearchParams(location.hash.replace(/^#/, ""));
  const query = new URLSearchParams(location.search);
  return fragment.get("session_id") || query.get("session_id");
}

// Preserve the bearer fallback, but blocked browser storage must not break cookies.
export const adminToken = {
  get() {
    try { return localStorage.getItem("admin_session_token"); }
    catch { return null; }
  },
  set(token) {
    try { localStorage.setItem("admin_session_token", token); }
    catch { console.warn("Browser storage unavailable; using the secure session cookie."); }
  },
  clear() {
    try { localStorage.removeItem("admin_session_token"); }
    catch { console.warn("Browser storage unavailable; session cookie logout was requested."); }
  },
};

export function signInError(error) {
  const status = error?.response?.status;
  if (!status || status >= 500) {
    return "Sign-in could not reach the server. Please try signing in again in a moment.";
  }
  if (status === 403) return "This Google account is not on the admin allowlist.";
  if (status === 401) return "This sign-in link is invalid or expired. Please sign in again.";
  return "Sign-in could not be completed. Please start again using Sign in with Google.";
}